export default __webpack_public_path__ + "static/media/portfolio-173.3e66d700.jpg";